import { NewzooToDatabrain } from '@intelligence/utils/constant';

// 数据源
export const DATA_SOURCES_MAPPING = {
  STEAM_CHARTS: 'steamcharts',
  NEWZOO: 'newzoo',
  MSCIENCE: 'mscience',
  NPD: 'npd',
};

// 数据源名称
export const DATA_SOURCES_NAMES_MAPPING = {
  [DATA_SOURCES_MAPPING.STEAM_CHARTS]: 'Steam Charts',
  [DATA_SOURCES_MAPPING.NEWZOO]: NewzooToDatabrain,
  [DATA_SOURCES_MAPPING.MSCIENCE]: 'MScience',
  [DATA_SOURCES_MAPPING.NPD]: 'NPD',
};

// 所有的数据源
export const ALL_DATA_SOURCES = [
  DATA_SOURCES_MAPPING.STEAM_CHARTS,
  DATA_SOURCES_MAPPING.NEWZOO,
  DATA_SOURCES_MAPPING.MSCIENCE,
  DATA_SOURCES_MAPPING.NPD,
];
